module.exports = __webpack_public_path__ + "img/img_6.2fbe456a.jpg";